module.exports = __webpack_public_path__ + "fb82ecbda9a260dbe58497b079be9af7.pdf";